function Video() {
    return (
        <video className="body-bg" autoPlay loop muted>
            <source src="/images/video.mp4" type="video/mp4"/>
        </video>
    );
}

export default Video;
